import actions from '../../actionTypes';

export default zone => {
  return {
    type: actions.REMOVE_ZONE,
    zone
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zones/actions/removeZone.js